module.exports = __webpack_public_path__ + "img/below-white.53e8fc15.svg";